import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ModalWrapper from 'components/ModalWrapper';
import CancelIcon from '@mui/icons-material/Cancel';

const Modal = ({ open, setOpen, error }) => {
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <ModalWrapper>
        <CancelIcon className="close-icon" onClick={handleClose} />
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ textAlign: 'center' }}>
            Payment declined due to the following reasons:
            <ul style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
              <li>{error?.decline_code?.replace(/_/g, ' ')}</li>
              <li>{error?.code?.replace(/_/g, ' ')}</li>
            </ul>
            <p>
              Please try with different card. If there is still error please
              contact&nbsp;
              <a href="mailto:support@shirtly.com">
                Shirtly INC (support@shirtly.com)
              </a>
              .
            </p>
          </DialogContentText>
        </DialogContent>
      </ModalWrapper>
    </Dialog>
  );
};

export default Modal;
